import React from 'react';
import SidebarMenuItem from './SidebarMenuItem';
import { menuItems } from './menuItems';
import { useAuth } from '@/hooks/useAuth';
import { useClientModules } from '@/hooks/useClientModules';

interface SidebarNavigationProps {
  activeModule: string;
  isCollapsed: boolean;
  expandedItems: string[];
  onModuleChange: (module: string) => void;
  onToggleExpanded: (itemId: string) => void;
}

const SidebarNavigation = ({ 
  activeModule, 
  isCollapsed, 
  expandedItems, 
  onModuleChange, 
  onToggleExpanded 
}: SidebarNavigationProps) => {
  const { user, profile } = useAuth();
  const { isMenuItemEnabled, isGlobalAdmin, hasModule } = useClientModules();
  
  // Filtrar itens do menu baseado no papel do usuário e módulos ativos
  const filteredMenuItems = menuItems.filter(item => {
    // Verificar adminOnly
    if ((item as any).adminOnly) {
      return profile?.role === 'admin';
    }
    
    // Técnicos não podem ver Contatos e Configurações
    if (profile?.role === 'technician') {
      if (item.id === 'contacts' || item.id === 'settings') {
        return false;
      }
    }

    // Items marcados como hiddenForTechnician não aparecem para técnicos
    if ((item as any).hiddenForTechnician && profile?.role === 'technician') {
      return false;
    }
    
    // Verificar se o módulo está habilitado para o cliente
    if (!isMenuItemEnabled(item.id)) {
      return false;
    }
    
    return true;
  }).map(item => {
    // Se tem children, filtrar children também
    if (item.children) {
      const filteredChildren = item.children.filter(child => {
        // Esconder "Configuração de IA" se módulo "IA Integrada" está ativo
        if (child.id === 'ai-config' && hasModule('ai_integrated')) {
          return false;
        }
        return isMenuItemEnabled(child.id);
      });
      
      // Se não sobrou nenhum child, ocultar o item pai
      if (filteredChildren.length === 0) {
        return null;
      }
      
      return { ...item, children: filteredChildren };
    }
    
    return item;
  }).filter(Boolean);

  return (
    <nav className="space-y-1 flex-1 overflow-y-auto scrollbar-hide">
      {filteredMenuItems.map((item) => (
        <SidebarMenuItem
          key={item.id}
          item={item}
          activeModule={activeModule}
          isCollapsed={isCollapsed}
          isExpanded={expandedItems.includes(item.id)}
          onItemClick={onModuleChange}
          onToggleExpanded={onToggleExpanded}
        />
      ))}
    </nav>
  );
};

export default SidebarNavigation;
